<template>

  <popover-box ref="popover" :parent="parent" :direction="direction" class="date-picker-popover">
    <date-picker v-model="selectedDate" :not-before="notBefore" :not-after="notAfter" lang="en" range confirm/>
    <popover-checkmark-btn @click.native="selectAttribute" :disabled="isInvalid"/>
  </popover-box>

</template>

<script>
import PopoverCheckmarkBtn from './PopoverCheckmarkBtn'
import PopoverBox from './PopoverBox'
import DatePicker from 'vue2-datepicker'
import popoverContainerMixin from './popoverContainerMixin'
import { cloneDeep } from 'lodash'

export default {
  mixins: [
    popoverContainerMixin
  ],
  components: {
    PopoverCheckmarkBtn,
    PopoverBox,
    DatePicker
  },
  props: {
    attribute: Object
  },
  data () {
    return {
      selectedDate: ''
    }
  },
  computed: {
    notBefore () {
      return new Date(this.attribute.min)
    },
    notAfter () {
      return new Date(this.attribute.max)
    },
    isInvalid () {
      return this.selectedDate === ''
    }
  },
  methods: {
    selectAttribute () {
      console.log(this.selectedDate)
      let chosenAttribute = cloneDeep(this.attribute)
      chosenAttribute.value = {
        min: this.selectedDate[0].toISOString().slice(0, 10),
        max: this.selectedDate[1].toISOString().slice(0, 10)
      }
      // TODO: figure out how the backend is expecting this attribute value to be?
      this.$refs.popover.dismiss()
      this.$emit('select', chosenAttribute)
    }
  }
}

</script>

<style lang="scss">
  .date-picker-popover.popover-box {
    overflow: visible;

    .popover-box__content {
      overflow: visible;
      display: flex;
    }
  }
</style>




// WEBPACK FOOTER //
// DatePickerPopover.vue?0f98d252